/* List of Redux constants */
export const CANDIDATE_MORE_VACANCIES_SET_LIST = '@candidate-more-vacancies/set-list';
export const CANDIDATE_MORE_VACANCIES_SET_LIST_LOADING = '@candidate-more-vacancies/set-list-loading';
export const CANDIDATE_MORE_VACANCIES_SET_LIST_RESET = '@candidate-more-vacancies/reset-list';

/* List of Sagas constants */
export const CANDIDATE_MORE_VACANCIES_GET_LIST = '@candidate-more-vacancies/get-list';


// WEBPACK FOOTER //
// ./src/actions/candidate/candidate-more-vacancies/types.js